import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const MaintenanceLazy = lazyLoader(
  () => import('./Maintenance' /* webpackChunkName: "maintenance" */),
);

const Maintenance = () => {
  return (
    <Suspense fallback={null}>
      <MaintenanceLazy />
    </Suspense>
  );
};

export default Maintenance;
